import './grid.scss';

class GridVideoItem {
    constructor($element) {
        this.$gridVideoItem = $element;
        this.$gridItemDisclaimer = this.$gridVideoItem.querySelector('[data-grid-item="disclaimer"]');
        this.$gridItemAccept = this.$gridVideoItem.querySelector('[data-grid-item="accept"]');

        const intervalId = setInterval(() => {
            if (typeof ppms !== 'undefined') {
                clearInterval(intervalId);
                this.initialize();
            }
        }, 100);

        // Clear the interval after a certain amount of time to prevent infinite loop
        setTimeout(() => {
            clearInterval(intervalId);
        }, 10000);
    }

    initialize() {
        const onFulfilled = (settings) => {
            if (settings.consents.analytics.status === 1) {
                this.setCookieConsentForCliplister();
                this.initVideoContent();
            }

            if (this.$gridItemAccept) {
                this.$gridItemAccept.onclick = () => {
                    const onFulfilled = () => {
                        this.setCookieConsentForCliplister();
                        window.location.reload();
                    };

                    ppms.cm.api('setComplianceSettings', {consents: {analytics: {status: 1}}}, onFulfilled);
                };
            }
        };

        ppms.cm.api('getComplianceSettings', onFulfilled);
    }

    initVideoContent() {
        const $VideolyserIframe = this.$gridVideoItem.querySelector('[data-videolyser="root"]');

        if ($VideolyserIframe) {
            $VideolyserIframe.src = $VideolyserIframe.dataset.srcUrl;
            $VideolyserIframe.removeAttribute('aria-hidden');
            this.$gridItemDisclaimer.remove();
        }

        const $Cliplister = this.$gridVideoItem.querySelector('[data-cliplister="root"]');

        if ($Cliplister) {
            if ($Cliplister.dataset.cliplisterActive === 'true') {
                this.$gridItemDisclaimer.remove();
            }
        }

        const $UniversalVideo = this.$gridVideoItem.querySelector('[data-universal-video="root"]');

        if ($UniversalVideo) {
            if ($UniversalVideo.dataset.universalVideoActive === 'true') {
                this.$gridItemDisclaimer.remove();
            }
        }
    }

    setCookieConsentForCliplister () {
        // we need our own cookie to use this in the cliplister template
        const date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 Days till now
        const expires = "expires=" + date.toUTCString();

        document.cookie = "cookieConsentAnalytics=True; " + expires + "; path=/";
    }
}

export {GridVideoItem};

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$gridVideoItem = $context.querySelectorAll('[data-grid-video-item="root"]');

    if ($$gridVideoItem.length > 0) {
        $$gridVideoItem.forEach(($gridVideoItem) => {
            const gridVideoItem = new GridVideoItem($gridVideoItem); // eslint-disable-line
        });
    }
});